import PropTypes from 'prop-types';
import React from 'react';
import { getTextFromPasteEvent } from '@bibliocommons/utils-browser';

import fieldErrorWrapper from '@bibliocommons/shared-field-error-wrapper';
import { bindAll } from '@bibliocommons/utils-react';
import CharacterCount from '@bibliocommons/base-character-count';
import { fieldErrorsShape } from '@bibliocommons/bc-prop-types';

import './AccessibleTextField.scss';

export class AccessibleTextField extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  componentDidMount() {
    // for testing purposes.
  }

  handleChange() {
    const { value } = this._textInput;
    if (this.props.handleChange) {
      this.props.handleChange(value);
    }
  }

  handlePaste(e) {
    const value = getTextFromPasteEvent(e);
    if (this.props.handlePaste) {
      this.props.handlePaste(value);
    }
  }

  focus() {
    if (this._textInput) {
      this._textInput.focus();
    }
  }

  renderInfo() {
    return this.props.info ? <div className="info">{this.props.info}</div> : null;
  }

  renderInputIcon() {
    return this.props.inputIcon ? this.props.inputIcon : null;
  }

  renderCharacterCount() {
    const { value, suggestedMaxLength, maxLength, characterCountSrOnly } = this.props;
    if (suggestedMaxLength || maxLength) {
      return (
        <CharacterCount
          screenReaderOnly={characterCountSrOnly}
          count={value ? value.length : 0}
          limit={suggestedMaxLength || maxLength}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div className="cp-accessible-text-field clearfix">
        <div className="input-holder">
          <input
            id={this.props.id}
            type={this.props.type}
            className={`form-control ${this.props.className}`}
            ref={el => {
              this._textInput = el;
            }}
            aria-labelledby={this.props.labelledById}
            aria-describedby={this.props.describedById}
            disabled={this.props.disabled}
            onChange={this.handleChange}
            onPaste={this.handlePaste}
            onFocus={this.props.handleFocus}
            onBlur={this.props.handleBlur}
            maxLength={this.props.maxLength}
            name={this.props.name}
            pattern={this.props.pattern}
            placeholder={this.props.placeholder}
            readOnly={this.props.readOnly}
            required={this.props.required}
            value={this.props.value}
            autoFocus={this.props.focus}
            data-test-id={this.props.testId}
          />
          {this.renderInputIcon()}
        </div>
        {this.renderInfo()}
        {this.renderCharacterCount()}
      </div>
    );
  }
}

const fieldErrorWrapperPropTypes = {
  fieldErrors: PropTypes.objectOf(fieldErrorsShape),
  errorKey: PropTypes.string
};

AccessibleTextField.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  describedById: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  handlePaste: PropTypes.func,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelledById: PropTypes.string.isRequired,
  suggestedMaxLength: PropTypes.number,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  pattern: PropTypes.string,
  type: PropTypes.string,
  focus: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string,
  testId: PropTypes.string,
  characterCountSrOnly: PropTypes.bool,
  inputIcon: PropTypes.element,
  ...fieldErrorWrapperPropTypes
};

AccessibleTextField.defaultProps = {
  type: 'text'
};

export default fieldErrorWrapper(AccessibleTextField);
